import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../util/utils';
import Ellipses from '../EllipsesControl/EllipsesPresets';

export const NoResultsPlaceholder = ({placeholder}) => {
	return (
		<StyledNoResultsPlaceholder className="StyledNoResultsPlaceholder">
			<Ellipses.Single>{placeholder}</Ellipses.Single>
		</StyledNoResultsPlaceholder>
	);
};

NoResultsPlaceholder.propTypes = {
	placeholder: PropTypes.string
};

NoResultsPlaceholder.defaultProps = {
	placeholder: labels.noResultsFound
};

export default NoResultsPlaceholder;

const StyledNoResultsPlaceholder = styled.section`
	display: flex;
	min-height: var(--px-300);
	color: var(--neutrals-700);
	.ellipses {
		font-size: var(--px-14);
		font-weight: 400;
		justify-content: center;
	}
`;
